import React from 'react';
import PropTypes from 'prop-types';
import { riskColors } from 'utils/constants/risks';
import styles from './index.module.scss';
import MapWithRegions from 'components/Map/MapOptions/MapWithRegions';
import Image from 'components/Image';
import { images } from 'utils/icons';
import { LOCATION_MODE } from '../../../utils/constants/Map';

const MapArray = ({ value }) => {
  const polygons = [
    {
      isFilled: true,
      color: riskColors[value.riskLevel],
      paths: value.boundary,
    },
  ];

  const Address = ({ children }) => {
    return (
      <div className={styles.address}>
        <Image src={images.iconSite} className={styles.addressImage} />
        {children}
      </div>
    );
  };

  Address.propTypes = {
    children: PropTypes.string,
  };

  const PatrolPath = () => {
    return (
      <table>
        <thead className={styles.boundaryHeader}>
          <tr>
            <th>Index</th>
            <th className={styles.tMargin}>Longitude</th>
            <th className={styles.tMargin}>Latitude</th>
          </tr>
        </thead>
        <tbody>
          {value.boundary.map((bound, index) => {
            return (
              <tr key={index}>
                <td className={styles.tMargin}>{index}</td>
                <td className={styles.tMargin}>{bound.lng}</td>
                <td className={styles.tMargin}>{bound.lat}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    );
  };

  const Maps = () => (
    <section className={styles.map}>
      <MapWithRegions
        center={value.center}
        addressLocationMarker={value.addressLocationMarker}
        secondaryPolygon={polygons}
        isZoomEnabled={false}
        secondaryPolygonMode={
          value.additionalPolygonMode || LOCATION_MODE.HIGH_DETAIL
        }
        zonePanel={value.zonePanel}
        mapInForm={true}
      />
    </section>
  );

  return (
    <>
      {value.address && <Address>{value.address}</Address>}
      {value.tableView && <PatrolPath />}
      <Maps />
    </>
  );
};

MapArray.propTypes = {
  value: PropTypes.object.isRequired,
};

export default MapArray;
